import { configureStore } from '@reduxjs/toolkit'
import authReducer from './../features/authSlice'
import uiReducer from './../features/uiReducer'

import { persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,} from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
const persistConfig = {
    key: 'root',
    version: 1,
    storage,
}
const persistConfigUI = {
    key: 'ui',
    version: 1,
    storage,
}

//console.log(persistConfig);

const persistedReducerAuth = persistReducer(persistConfig, authReducer)
const persistedReducerUI = persistReducer(persistConfigUI, uiReducer)

export const store = configureStore({
  reducer: {
    auth : persistedReducerAuth,
    ui : persistedReducerUI
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)
